function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ListMetricsTitle from './ListMetricsTitle';
import { HelpButton } from '../../HelpButton';
import { Text } from '../../Text';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListMetrics(props) {
  const {
    content,
    metricsClassName,
    isMetricEmpty,
    emptyMetricMessage,
    isDesktopView
  } = props;
  const listMetricsClasses = classNames({
    [moduleStyles['sib-list__metrics']]: true,
    [metricsClassName]: !!metricsClassName
  });
  if (isMetricEmpty) {
    return /*#__PURE__*/React.createElement(Text, {
      size: "md",
      color: "var(--sib-color_content-secondary)"
    }, emptyMetricMessage);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: listMetricsClasses
  }, [...content].splice(0, 5).map((metric, index) => {
    const {
      id = index,
      title = '',
      value = '',
      percentCompletion = '',
      isValueLink = false,
      valueUrl = '',
      valueLinkProps = {},
      helpButtonData = null
    } = metric;
    return /*#__PURE__*/React.createElement("div", {
      key: id + title + index,
      className: moduleStyles['sib-list__metric']
    }, /*#__PURE__*/React.createElement(ListMetricsTitle, {
      title: title
    }), /*#__PURE__*/React.createElement("div", {
      className: moduleStyles['sib-list__metric-stat']
    }, isValueLink ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", _extends({
      href: valueUrl
    }, valueLinkProps, {
      className: moduleStyles['sib-list__metric-value-link']
    }), value)) : /*#__PURE__*/React.createElement(Text, {
      size: "lg",
      fontFamily: "bold",
      color: "var(--sib-color_content-primary)"
    }, value), /*#__PURE__*/React.createElement("div", {
      className: moduleStyles['sib-list__metric-value']
    }, percentCompletion && /*#__PURE__*/React.createElement(Text, {
      size: "sm",
      color: "var(--sib-color_content-secondary)"
    }, percentCompletion), helpButtonData && isDesktopView && /*#__PURE__*/React.createElement(HelpButton, helpButtonData))));
  })), !isDesktopView && [...content].splice(0, 5).map((metric, index) => {
    const {
      helpButtonData = null,
      helpButtonDescInMobile = ''
    } = metric;
    return /*#__PURE__*/React.createElement(React.Fragment, null, (helpButtonData || helpButtonDescInMobile) && /*#__PURE__*/React.createElement("div", {
      key: index,
      className: moduleStyles['sib-list__metrics-mobile-help-button'],
      style: index === 0 ? {
        marginTop: 'var(--brand-spacing_4)'
      } : {}
    }, helpButtonData && /*#__PURE__*/React.createElement(HelpButton, _extends({}, helpButtonData, {
      style: {
        padding: '0px'
      },
      hasPopover: false
    })), helpButtonDescInMobile && /*#__PURE__*/React.createElement(Text, {
      size: "sm",
      fontFamily: "regular"
    }, helpButtonDescInMobile)));
  }));
}
ListMetrics.defaultProps = {
  content: [],
  metricsClassName: '',
  emptyMetricMessage: '',
  isMetricEmpty: false,
  isDesktopView: true
};
ListMetrics.propTypes = {
  metricsClassName: PropTypes.string,
  emptyMetricMessage: PropTypes.string,
  isMetricEmpty: PropTypes.bool,
  isDesktopView: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    percentCompletion: PropTypes.string,
    isValueLink: PropTypes.bool,
    helpButtonData: PropTypes.object,
    valueUrl: PropTypes.string,
    valueLinkProps: PropTypes.object,
    helpButtonDescInMobile: PropTypes.string,
    id: PropTypes.string
  }))])
};
export default ListMetrics;